import clsx from 'clsx';
import PropTypes from 'prop-types';
import HotelItineraryContent from '../../../../TravelOption/HotelInformation/HotelItinerary/HotelItineraryContent';

const HotelCompareTable = ({
  hotelTravelOptions,
  doShowViewButtonColumn,
  doShowPrice,
  hotelRateDisplayPreference,
  doShowMarkupRates,
  doShowHotelSourceInHotelName,
}) =>
  hotelTravelOptions &&
  hotelTravelOptions.map((travelOption, index) => (
    <HotelItineraryContent
      itinerary={travelOption.hotelItinerary}
      key={travelOption.itineraryId}
      doShowViewDetailButton={doShowViewButtonColumn}
      wrapperClassName={clsx({ 'mt-10': !doShowViewButtonColumn && index > 0 })}
      doShowPrice={doShowPrice}
      isEmailView
      pricingPreference={hotelRateDisplayPreference}
      doShowMarkupRates={doShowMarkupRates}
      doShowHotelSourceInHotelName={doShowHotelSourceInHotelName}
      doShowAgentCommission={false}
      travelOption={travelOption}
    />
  ));

HotelCompareTable.propTypes = {
  hotelTravelOptions: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  doShowViewButtonColumn: PropTypes.bool,
  doShowPrice: PropTypes.bool,
  hotelRateDisplayPreference: PropTypes.number,
  doShowMarkupRates: PropTypes.bool,
  doShowHotelSourceInHotelName: PropTypes.bool,
};

HotelCompareTable.defaultProps = {
  doShowViewButtonColumn: true,
  doShowPrice: true,
  hotelRateDisplayPreference: undefined,
  doShowMarkupRates: false,
  doShowHotelSourceInHotelName: true,
};

export default HotelCompareTable;
